const HowToAccessCourseMaterials = () => (
  <div>
    <ol className="list-decimal list-inside text-grays-dark space-y-4">
      <li>
        Visit{' '}
        <a className="underline text-blue-800" href="http://ctionline.com/">
          CTI Online
        </a>
      </li>
      <li>
        Click <strong>Sign In</strong>
      </li>
      <li>
        Click the Menu icon in the top right corner of the page next to the shopping cart and click on{' '}
        <strong>Admin</strong>
        <div className="my-4 border rounded">
          <img src="/images/faqs/ham_menu_hided.png" alt="Courses to start" />
        </div>

      </li>
      <li>
        Click on <strong>Course Materials</strong> to view materials for courses you have been enrolled in or have already completed 
        <ol className="list-inside list-[lower-alpha] text-grays-dark space-y-4 ml-4">
            <li>
                For Virtual Classroom or in-person instructor-led courses not yet completed, you will only have access to the workbook *
                <div className="my-2 border rounded">
                    <img src="/images/faqs/course_material1.png" alt="Courses to start" />
                </div>
            </li>
            <li>
                Once a Virtual Classroom course is completed you will have access to the workbook and a recording of the course content 
                <div className="my-2 border rounded">
                    <img src="/images/faqs/course_content1.png" alt="Courses to start" />
                </div>
            </li>

        </ol>
      </li>
      <strong>*Note:</strong> Course workbooks for Virtual Classroom and in-person instructor-led courses may also be found on the Course Detail page inside the Learning Management System  

    </ol>
  </div>
)

export default HowToAccessCourseMaterials
